import axios from 'axios';

export const fetchAddress = async (countryCode, query, restParams = {}) => {
    return await axios.get(process.env.REACT_APP_HERE_API_URL, {
        params: {
            q: query,
            in: `countryCode:${countryCode}`,
            apiKey: process.env.REACT_APP_HERE_API_KEY,
        },
    });
};
